import useAssetNewOrderedAddOns from 'modules/addOns/useAssetNewOrderedAddOns';
import type { AssetDetails } from 'modules/queries/asset/useDetails';
import { acronisProductCodes } from 'utility/acronisProductMap';

const SECURITY_ADD_ON_CODES = [
	'ServerSecurity.ThreatDown',
	'ServerSecurity.Imunify360',
	'AcronisEDR',
];

/**
 * What the backups and security chips of a server in a server list need to know
 * about its add-ons. An add-on ordered for the server counts as present, with
 * the status `New`, until the server's association details list it.
 *
 * It does not wait for the order list or the carts to load. A server list shows
 * its servers at once, and an add-on that was just ordered shows as ordered
 * once those requests finish.
 */
const useServerAddOnStatus = (assetDetails: AssetDetails) => {
	const { assetNewOrderedAddOns } = useAssetNewOrderedAddOns(assetDetails);

	const isNewOrderedBackups = assetNewOrderedAddOns.some(({ code }) =>
		acronisProductCodes.includes(code),
	);
	const isNewOrderedSecurity = assetNewOrderedAddOns.some(({ code }) =>
		SECURITY_ADD_ON_CODES.includes(code),
	);
	const securityAssociation = assetDetails.associationDetails?.find(
		({ type }) => SECURITY_ADD_ON_CODES.includes(type),
	);

	return {
		isNewOrderedBackups,
		hasEnhancedSecurity: Boolean(securityAssociation) || isNewOrderedSecurity,
		enhancedSecurityStatus:
			securityAssociation?.status || (isNewOrderedSecurity ? 'New' : undefined),
	};
};

export default useServerAddOnStatus;
